<template>
  <div class="orgTypePage">
    <el-table
      stripe
      :data="orgTypeData"
      style="width: 100%"
      border
      height="100%"
      size="mini"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      default-expand-all
    >
      <el-table-column type="index" width="50" align="center"></el-table-column>
      <el-table-column
        prop="name"
        label="组织类别"
        min-width="110px"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="productionLine"
        label="是否生产线"
        align="center"
        width="130px"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="textSuccess" v-if="scope.row.productionLine">生产线</span>
          <span class="textWarning" v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enable"
        label="状态"
        align="center"
        width="130px"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="textSuccess" v-if="scope.row.enable">启用</span>
          <span class="textWarning" v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center"
        width="130px"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="新建"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="addFactoryOrg($event, scope.row)"
              class="el-icon-plus"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="editFactoryOrg($event, scope.row)"
              class="el-icon-edit"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.enable"
            class="item"
            effect="dark"
            content="禁用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="disableFactoryOrg($event, scope.row)"
              class="iconfont icon-jinyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="启用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="enableFactoryOrg($event, scope.row)"
              class="iconfont icon-qiyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="上移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveUpFactoryOrg($event, scope.row)"
              class="el-icon-arrow-up"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="下移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveDownFactoryOrg($event, scope.row)"
              class="el-icon-arrow-down"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { apiFactoryOrgTypeGrid } from "@/api/plantSetting.js";
export default {
  data() {
    return {
      orgTypeData: [],
    };
  },
  methods: {
    // 组织结构类别表格
    async getFactoryOrgTypeGrid(remove, callback) {
      if (remove != "noRemove") {
        this.orgTypeData = [];
      }
      const res = await apiFactoryOrgTypeGrid();
      // console.log(res);
      if (res.code == 0) {
        this.orgTypeData = res.data;
        this.$parent.getTypeList();
        // this.$parent.pullDownData.typeList = res.data;
        if (callback) callback();
      }
    },
    // 新建
    addFactoryOrg(e, row) {
      this.$parent.addNewBtn(e, row);
    },
    // 修改
    editFactoryOrg(e, row) {
      this.$parent.editFactoryOrgType(e, row);
    },
    // 禁用
    disableFactoryOrg(e, row) {
      this.$parent.disableFactoryOrg(e, row);
    },
    // 启用
    enableFactoryOrg(e, row) {
      this.$parent.enableFactoryOrg(e, row);
    },
    // 上移
    moveUpFactoryOrg(e, row) {
      this.$parent.moveUpFactoryOrg(e, row);
    },
    // 下移
    moveDownFactoryOrg(e, row) {
      this.$parent.moveDownFactoryOrg(e, row);
    },
  },
};
</script>

<style lang="less" scoped>
.orgTypePage {
  height: 100%;
}
</style>